<div id="container">
    <!-- <p>{{Anzeige.length}}</p> -->
    <div *ngIf="Anzeige.length > 0; else elseBlock" style="width:100%" class="_cardHolder">
    <ng-container
        *ngFor="
            let item of Anzeige | slice: (page - 1) * pageSize:page * pageSize
        "
    >
        <!-- <ng-container *ngFor="let item of Anzeige"> -->
        <mat-card @itemAppear>
            <div class="image">
                <img
                    src="{{ item.ta_trauerkartePfad }}/{{
                        item.ta_imageanzeige
                    }}"
                    (load)="isImageLoad($event)"
                    class="karte_image"
                />
                <img
                    src="/files/gedenkportal/assets/icons/wait_image.svg"
                    width="50px"
                    height="50px"
                    class="loader_image"
                />
            </div>
            <div class="detailV">
                <div class="ver_name">
                    {{ item.ta_firstname }} {{ item.ta_name }}
                </div>
                <div class="born" *ngIf="item.ta_birthdate">
                    <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                            <path
                                fill="currentColor"
                                d="M21 13H14.4L19.1 17.7L17.7 19.1L13 14.4V21H11V14.3L6.3 19L4.9 17.6L9.4 13H3V11H9.6L4.9 6.3L6.3 4.9L11 9.6V3H13V9.4L17.6 4.8L19 6.3L14.3 11H21V13Z"
                            />
                    </svg>
                    <div>{{ item.ta_birthdate | date: "dd.MM.yyyy" }}</div>
                </div>
                <div class="died">
                    <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                        <g >
                            <path
                                fill="currentColor"
                                d="M10.5,2H13.5V8H19V11H13.5V22H10.5V11H5V8H10.5V2Z"
                            />
                        </g>
                    </svg>
                   <div>{{ item.ta_deathdate | date: "dd.MM.yyyy" }}</div>
                </div>
                <br />
                <div class="konolenz_counter_holder">
                    <div class="kerzen_counter counter">
                        <svg
                            style="width: 24px; height: 24px"
                            viewBox="0 0 24 24"
                        >
                            <path
                                fill="currentColor"
                                d="M12.5,2C10.84,2 9.5,5.34 9.5,7A3,3 0 0,0 12.5,10A3,3 0 0,0 15.5,7C15.5,5.34 14.16,2 12.5,2M12.5,6.5A1,1 0 0,1 13.5,7.5A1,1 0 0,1 12.5,8.5A1,1 0 0,1 11.5,7.5A1,1 0 0,1 12.5,6.5M10,11A1,1 0 0,0 9,12V20H7A1,1 0 0,1 6,19V18A1,1 0 0,0 5,17A1,1 0 0,0 4,18V19A3,3 0 0,0 7,22H19A1,1 0 0,0 20,21A1,1 0 0,0 19,20H16V12A1,1 0 0,0 15,11H10Z"
                            />
                        </svg>
                        <div *ngIf="item.c_kerze; else keineKerze">
                            {{ item.c_kerze }}
                        </div>
                        <ng-template #keineKerze>0</ng-template>
                    </div>
                    <div class="kondolenzen_counter counter">
                        <svg
                            style="width: 24px; height: 24px"
                            viewBox="0 0 24 24"
                        >
                            <path
                                fill="currentColor"
                                d="M20.71,7.04C20.37,7.38 20.04,7.71 20.03,8.04C20,8.36 20.34,8.69 20.66,9C21.14,9.5 21.61,9.95 21.59,10.44C21.57,10.93 21.06,11.44 20.55,11.94L16.42,16.08L15,14.66L19.25,10.42L18.29,9.46L16.87,10.87L13.12,7.12L16.96,3.29C17.35,2.9 18,2.9 18.37,3.29L20.71,5.63C21.1,6 21.1,6.65 20.71,7.04M3,17.25L12.56,7.68L16.31,11.43L6.75,21H3V17.25Z"
                            />
                        </svg>
                        <div *ngIf="item.c_kondolenz; else keineKondolenz">
                            {{ item.c_kondolenz }}
                        </div>
                        <ng-template #keineKondolenz>0</ng-template>
                    </div>
                </div>

                <!-- <button mat-button [routerLink]="['/anzeigen-detail', item.a_id+'_'+item.a_name+'_'+item.a_vorname]" class="block">Anzeigen</button> -->
                <button
                    mat-button
                    [routerLink]="['/anzeigen-detail', item.ta_id]"
                    class="block"
                    (click)="
                        sendData(
                            item.ta_name,
                            item.ta_firstname,
                            item.ta_trauerkartePfad,
                            item.ta_imageanzeige
                        )
                    "
                >
                    Anzeigen
                </button>
            </div>
        </mat-card>
    </ng-container>


    <ngb-pagination
        [collectionSize]="collectionSize"
        [(page)]="page"
        [maxSize]="5"
        [rotate]="false"
        [ellipses]="false"
        [boundaryLinks]="true"
        [pageSize]= "6"
        [size]= "6"

    ></ngb-pagination>
</div>
<ng-template #elseBlock><h3 style="text-align:center;display:block;width:100%;color:#fff;font-size:1rem">Noch keine Anzeige vorhanden.</h3></ng-template>
</div>
